const inQueryObject = (queryObject, key, toLookFor) => {
  const object = queryObject?.[key];
  return object?.indexOf(toLookFor) >= 0;
};

export default inQueryObject;
